import React from 'react';
import { ExternalLink } from 'lucide-react';

/**
 * DemoBanner — Sticky top banner shown to demo users.
 * Links to the sign-up page for conversion.
 */
const DemoBanner = () => {
    return (
        <div style={{
            background: 'linear-gradient(135deg, var(--primary), #6366f1)',
            color: 'white',
            padding: '10px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            fontSize: '0.9rem',
            fontWeight: 500,
            position: 'sticky',
            top: 0,
            zIndex: 9999,
            flexShrink: 0
        }}>
            <span>👀 You're viewing a demo of Always In</span>
            <a
                href="https://alwaysin.uk/contact.html"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    background: 'rgba(255,255,255,0.2)',
                    color: 'white',
                    padding: '4px 14px',
                    borderRadius: '6px',
                    textDecoration: 'none',
                    fontWeight: 600,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    fontSize: '0.85rem',
                    border: '1px solid rgba(255,255,255,0.3)',
                    transition: 'background 0.2s'
                }}
                onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.35)'}
                onMouseOut={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
            >
                Sign Up <ExternalLink size={14} />
            </a>
        </div>
    );
};

export default DemoBanner;
